import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getGAMainData } from '../../api/auth';
import Header from '../../component/Header';
import NavbarGA from '../../component/NavBarGA';
import Spinner from '../../component/Spinner';

function Main() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [mainData, setMainData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mesga");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
                const result = await getGAMainData();
                console.log('result', result);
                if (result.ok === true) {
                    setDate(dayjs(result.timestamp).format('M/D/YYYY(ddd)'));
                    setMainData(result.data);
                } else {
                    alert("API CALL FAIL");
                }
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <NavbarGA />
            <div className='p-1 text-md'>
                <div>
                    {date}
                </div>
                {
                    parseInt(mainData?.SelectCnt ?? 0) > 0 &&
                    mainData?.results?.filter(v => v.ITMCTG === "PDPDOC").map((v, i) => {
                        const ProdCarsArray = [];
                        const SEQINFOArray = [];
                        const LINESTATUSArray = [];
                        const SUBLINEArray = [];
                        try {
                            const xmlString = v.TXTVAL;
                            const domParser = new DOMParser();
                            const xmlDoc = domParser.parseFromString('<root>' + xmlString + '</root>', "application/xml");

                            // ProdCar
                            const ProdCars = xmlDoc.querySelectorAll("ProdCar");
                            for (let prodCar of ProdCars) {
                                ProdCarsArray.push({
                                    ItemName: prodCar.getAttribute("ItemName"),
                                    ItemValue: prodCar.getAttribute("ItemValue"),
                                });
                            }

                            // SEQINFO
                            const SEQINFOS = xmlDoc.querySelectorAll("SEQINFO");
                            for (let SEQINFO of SEQINFOS) {
                                SEQINFOArray.push({
                                    ItemName: SEQINFO.getAttribute("ItemName"),
                                    ItemValue: SEQINFO.getAttribute("ItemValue"),
                                });
                            }

                            // LINESTATUS
                            const LINESTATUSS = xmlDoc.querySelectorAll("LINESTATUS");
                            for (let LINESTATUS of LINESTATUSS) {
                                LINESTATUSArray.push({
                                    LineName: LINESTATUS.getAttribute("LineName"),
                                    GAP: LINESTATUS.getAttribute("GAP"),
                                    PEN: LINESTATUS.getAttribute("PEN"),
                                    INTRANSIT: LINESTATUS.getAttribute("INTRANSIT"),
                                    MCNT: LINESTATUS.getAttribute("MCNT"),
                                    KCNT: LINESTATUS.getAttribute("KCNT"),
                                    TAR: LINESTATUS.getAttribute("TAR"),
                                    Color: LINESTATUS.getAttribute("Color"),
                                    UPH: LINESTATUS.getAttribute("UPH"),
                                    DspOrder: LINESTATUS.getAttribute("DspOrder"),
                                });
                            }

                            // SUBLINE
                            const SUBLINES = xmlDoc.querySelectorAll("SUBLINE");
                            for (let SUBLINE of SUBLINES) {
                                SUBLINEArray.push({
                                    ItemName: SUBLINE.getAttribute("ItemName"),
                                    ItemValue: SUBLINE.getAttribute("ItemValue"),
                                    TAR: SUBLINE.getAttribute("TAR"),
                                    Color: SUBLINE.getAttribute("Color"),
                                });
                            }
                        } catch (err) {
                            console.log(err);
                        }

                        return (
                            <>
                                {
                                    ProdCarsArray?.length > 0 ? (
                                        <div className="relative overflow-x-auto mt-3">
                                            <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                                                <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                                                    <tr>
                                                        {ProdCarsArray?.map((v, i) => {
                                                            return (
                                                                <th scope="col" className="py-1">
                                                                    {v.ItemName}
                                                                </th>
                                                            )
                                                        })}
                                                    </tr>
                                                </thead>
                                                <tbody className="text-black">
                                                    <tr className='border-b'>
                                                        {ProdCarsArray?.map((v, i) => {
                                                            return (
                                                                <th className="py-1">
                                                                    {v.ItemValue}
                                                                </th>
                                                            )
                                                        })}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null
                                }
                                {
                                    SEQINFOArray?.length > 0 ? (
                                        <div className="relative overflow-x-auto">
                                            <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                                                <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                                                    <tr>
                                                        <th scope="col" className="py-1" style={{ width: '33.3%' }}>
                                                            SEQ
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '33.3%' }}>
                                                            LAST SEQ
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '33.3%' }}>
                                                            CTS
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-black">
                                                    <tr className='border-b'>
                                                        {SEQINFOArray?.map((v, i) => {
                                                            return (
                                                                <th className="py-1">
                                                                    {v.ItemValue}
                                                                </th>
                                                            )
                                                        })}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null
                                }
                                {
                                    LINESTATUSArray?.length > 0 ? (
                                        <div className="relative overflow-x-auto">
                                            <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                                                <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                                                    <tr>
                                                        <th scope="col" className="py-1" style={{ width: '20%' }}>
                                                            LINE
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '20%' }}>
                                                            GAP
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '20%' }}>
                                                            PEND.
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '20%' }}>
                                                            M/K
                                                        </th>
                                                        <th scope="col" className="py-1" style={{ width: '20%' }}>
                                                            UPH
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-black">
                                                    {LINESTATUSArray?.map((v, i) => {
                                                        return (
                                                            <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b border-t`}>
                                                                <th className="py-1 bg-slate-300">
                                                                    <span className="font-extrabold" style={{ color: v.Color }}>
                                                                        O
                                                                    </span>
                                                                    <span> </span>
                                                                    {v.LineName}
                                                                </th>
                                                                <th className="py-1">
                                                                    {v.GAP}
                                                                </th>
                                                                <th className="py-1">
                                                                    {v.PEN}
                                                                </th>
                                                                <th className="py-1">
                                                                    {v.LineName === 'BRM' || v.LineName === 'BFM' ? `${v.MCNT}/${v.INTRANSIT}/${v.KCNT}` : `${v.MCNT}/${v.KCNT}`}
                                                                </th>
                                                                <th className="py-1">
                                                                    {v.UPH}
                                                                </th>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null
                                }
                                {
                                    SUBLINEArray?.length > 0 ? (
                                        <div className="relative overflow-x-auto mt-3">
                                            <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                                                <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                                                    <tr>
                                                        <th scope="col" className="py-1">
                                                            LOC
                                                        </th>
                                                        <th scope="col" className="py-1">
                                                            BUF
                                                        </th>
                                                        <th scope="col" className="py-1">
                                                            TGT
                                                        </th>
                                                        <th scope="col" className="py-1">
                                                            LOC
                                                        </th>
                                                        <th scope="col" className="py-1">
                                                            BUF
                                                        </th>
                                                        <th scope="col" className="py-1">
                                                            TGT
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-black">
                                                    {SUBLINEArray?.map((v, i) => {
                                                        return i % 2 === 0 ? (
                                                            <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b border-t`}>
                                                                <th className="py-1 bg-slate-300 text-left">
                                                                    <span>&nbsp;&nbsp;&nbsp;</span>
                                                                    <span className="font-extrabold" style={{ color: SUBLINEArray[i].Color }}>
                                                                        O
                                                                    </span>
                                                                    <span> </span>
                                                                    {SUBLINEArray[i].ItemName}
                                                                </th>
                                                                <th className="py-1">
                                                                    {SUBLINEArray[i].ItemValue}
                                                                </th>
                                                                <th className="py-1">
                                                                    {SUBLINEArray[i].TAR}
                                                                </th>
                                                                {
                                                                    SUBLINEArray[i + 1] !== undefined ? (
                                                                        <>
                                                                            <th className="py-1 bg-slate-300 text-left">
                                                                                <span>&nbsp;&nbsp;&nbsp;</span>
                                                                                <span className="font-extrabold" style={{ color: SUBLINEArray[i + 1].Color }}>
                                                                                    O
                                                                                </span>
                                                                                <span> </span>
                                                                                {SUBLINEArray[i + 1].ItemName}
                                                                            </th>
                                                                            <th className="py-1">
                                                                                {SUBLINEArray[i + 1].ItemValue}
                                                                            </th>
                                                                            <th className="py-1">
                                                                                {SUBLINEArray[i + 1].TAR}
                                                                            </th>
                                                                        </>
                                                                    ) : null
                                                                }
                                                            </tr>
                                                        ) : null
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null
                                }
                            </>
                        )
                    })
                }
                {
                    parseInt(mainData?.SelectCnt ?? 0) > 0 &&
                    mainData?.results?.filter(v => v.ITMCTG === "ALARMDOC").map((v, i) => {
                        const LineStopArray = [];
                        try {
                            const xmlString = v.TXTVAL;
                            const domParser = new DOMParser();
                            const xmlDoc = domParser.parseFromString('<root>' + xmlString + '</root>', "application/xml");

                            const LineStops = xmlDoc.querySelectorAll("LineStop");
                            for (let LineStop of LineStops) {
                                LineStopArray.push(LineStop.innerHTML);
                            }
                        } catch (err) {
                            console.log(err);
                        }

                        return (
                            <>
                                {LineStopArray?.map((v, i) => {
                                    return (
                                        <div key={i} className={`${i === 0 ? 'mt-3' : ''} text-lg`}>
                                            {v}
                                        </div>
                                    )
                                })}
                            </>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Main;
